var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    cx: 25,
    cy: 32,
    r: 10,
    fill: "#727273",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,9H6a5.006,5.006,0,0,0-5,5V50a5.006,5.006,0,0,0,5,5H58a5.006,5.006,0,0,0,5-5V14A5.006,5.006,0,0,0,58,9ZM39,44a11.921,11.921,0,0,1-7-2.273,12,12,0,1,1,0-19.454A11.993,11.993,0,1,1,39,44Z",
    fill: "#727273"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    cx: 39,
    cy: 32,
    r: 10,
    fill: "#727273",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardBw);
export default __webpack_public_path__ + "static/media/mastercard-bw.813f88113d5f4bc382ae03a8f9902e56.svg";
export { ForwardRef as ReactComponent };